import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useProfile } from "../context/contextProfile";
import { usePayment } from "../context/contextPayment";
import { useThemeMode } from "../context/contextTheme";
import Navbar from "../components/navbar";
import SideNavbar from "../components/sidebar";
import Widget from "../components/buttons/widget";
import UpgradeCard from "../components/cards/upgrade-card";
import ProfileCard from "../components/cards/profile-card";
import Breadcrumb from "../components/breadcrumb";
import sidebarMap from "../config/menuMapping";
import Test from './test';

import DashboardAws from "./Dashboard/s-item-3-1-aws"
import ServiceModuleAws from "../layouts/aws/misconfig/scout/pages/Service";
import RegionViewAws from "../layouts/aws/misconfig/scout/pages/Region";

import DashboardAzure from "./Dashboard/s-item-3-2-azure"
import ServiceModuleAzure from "../layouts/azure/misconfig/scout/pages/Service";
import RegionViewAzure from "../layouts/azure/misconfig/scout/pages/Region";

export default function Main() {
  const { showUpgradeCard, showProfileCard } = useProfile();
  const { theme, mode } = useThemeMode();
  const { loadingPayment } = usePayment();

  return (
    <div
      className="main"
      style={{
        pointerEvents: loadingPayment ? "none" : "auto",
        backgroundColor: mode === "light" ? "#f3f3f3" : theme.background,
      }}
    >
      <div style={{ zIndex: 1060 }}><Widget /></div>
      <div className="z-2">
        {showUpgradeCard && <UpgradeCard />}
        {showProfileCard && <ProfileCard />}
      </div>

      <div className="z-1">
        <Navbar />
        <div className="layout-body">
          <SideNavbar />
          <div className="main-content text-light">
            <Breadcrumb />
            <Routes_comp />
          </div>
        </div>
      </div>
    </div>
  );
}

/* ✅ Dynamic Route Rendering */
function Routes_comp() {
  return (
    <Routes>
      {Object.values(sidebarMap).map((item) => (
        <React.Fragment key={item.id}>
          <Route path={item.path} element={<item.component title={item.title} />} />
          {item.subMenu &&
            Object.values(item.subMenu).map((sub) => (
              <React.Fragment key={sub.path}>
                <Route path={sub.path} element={<sub.component title={sub.title} />} />
                {sub.tabs &&
                  Object.values(sub.tabs).map((tab) => (
                    <Route
                      key={tab.path}
                      path={tab.path}
                      element={<tab.component title={tab.title} />}
                    />
                  ))}
              </React.Fragment>
            ))}
        </React.Fragment>
      ))}
      <Route path="/dashboard/cloud-dashboard/aws" element={<DashboardAws />} />
      <Route path="/dashboard/cloud-dashboard/aws/service/:service" element={<ServiceModuleAws />} />
      <Route path="/dashboard/cloud-dashboard/aws/service/:service/regions/:regions" element={<RegionViewAws />} />

      <Route path="/dashboard/cloud-dashboard/azure" element={<DashboardAzure />} />
      <Route path="/dashboard/cloud-dashboard/azure/service/:service" element={<ServiceModuleAzure />} />
      <Route path="/dashboard/cloud-dashboard/azure/service/:service/regions/:regions" element={<RegionViewAzure />} />
      
      
      <Route path="/test" element={<Test />} />
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}
